<template>
  <div class="index-top-info flex">
    <div class="date">
      <span class="today">今天，</span>
      <div class="time">
        <span>{{ dateText }}</span>
        <span>{{ weekdayText }}</span>
        <span>欢迎回到牛卡福应用平台</span>
      </div>
    </div>
    <div class="weather">
      <div class="flex">
        <div class="boxWrap">
          <iframe
            allowtransparency="true"
            frameborder="0"
            width="255"
            height="64"
            scrolling="no"
            src="//tianqi.2345.com/plugin/widget/index.htm?s=2&z=2&t=1&v=2&d=1&bd=0&k=000000&f=000000&ltf=009944&htf=cc0000&q=1&e=0&a=0&c=54511&w=255&h=64&align=right"
          />
        </div>
      </div>
    </div>
    <div v-if="corpCertityStatus" class="verificationSMS">
      <div class="verificationSMS-content">
        <i class="iconfont el-foremail" />
        <p>经办人短信验证</p>
        <p>
          <span v-if="agentSMSValidateStatus === 1" class="inEffect">生效中</span>
          <span v-if="agentSMSValidateStatus === 2" class="unverified">未验证</span>
          <span v-if="agentSMSValidateStatus === 3" class="expired">已过期</span>
          <span v-if="agentSMSValidateStatus === 4" class="unverified">即将过期</span>
          <a @click="handleVerification">前往验证</a>
        </p>
      </div>
    </div>
    <AgentSMS v-if="SMSDialogShow" :show="SMSDialogShow" @cancel="SMSDialogShow = false" />
  </div>
</template>
<script>
import { stampTurnsTime } from '@/utils/index';
import AgentSMS from './components/agentSMS.vue';

export default {
  components: {
    AgentSMS,
  },
  data() {
    return {
      dateText: '',
      weekdayText: '',
      SMSDialogShow: false,
    };
  },
  computed: {
    // 经办人短信验证状态
    // 1生效中 2未验证 3已过期 4即将过期
    agentSMSValidateStatus() {
      return this.$store.state.agentSMSValidateStatus;
    },
    corpCertityStatus() {
      return this.$store.state.corpCertityStatus;
    },
  },
  async created() {
    let date = stampTurnsTime(new Date())
      .substr(0, 10)
      .split('-');
    this.dateText = date[0] + '年' + date[1] + '月' + date[2] + '日';
    let weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    let myddy = new Date().getDay();
    this.weekdayText = weekday[myddy];
  },
  methods: {
    handleVerification() {
      this.SMSDialogShow = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.boxWrap {
  display: inline-block;
  width: 230px;
  // height: 60px;
  overflow: hidden;
  position: relative;
  left: 10px;
  top: 30px;
}
#mobsf {
  position: absolute;
  left: 0;
  top: -35px;
}
.index-top-info {
  width: 100%;
  height: 95px;
  background-image: url(../images/home_page/home_page@3x.png);
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 47% 95px;
  position: relative;
  .date {
    padding-top: 10px;
    margin-right: 15.4%;
    .today {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: rgba(24, 24, 24, 1);
      line-height: 30px;
      margin-bottom: 3px;
    }
    .time {
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 22px;
      margin: 10px 0 25px 0;
      span {
        margin-right: 20px;
      }
    }
  }
  .weather {
    height: 58px;
    font-size: 50px;
    font-weight: bold;
    color: rgba(18, 28, 64, 1);
    line-height: 58px;
    position: relative;
    z-index: 1;
    margin-right: 22px;
    .tq {
      width: 41.5px;
      height: 41.5px;
    }
    .text {
      width: 196px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        width: 1px;
        height: 7px;
        background: #d8dee3;
        margin: 0 9px;
      }
    }
    .flex {
      // padding-top: 10px;
      align-items: center;
      margin-bottom: 15px;
      height: 37px;
      font-size: 32px;
      font-weight: bold;
      color: rgba(24, 24, 24, 1);
      line-height: 37px;
      h3 {
        margin-right: 22px;
        color: #181818 !important;
      }
    }
  }

  .verificationSMS {
    font-size: 14px;
    margin-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &-content {
      padding-left: 28px;
    }
    i {
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -30px;
      font-size: 24px;
      color: #2154bd;
    }
    p {
      margin-bottom: 10px;
      color: #181818;
      span {
        margin-right: 5px;
        font-weight: bold;
        &.unverified {
          color: #f59a23;
        }
        &.inEffect {
          color: #139146;
        }
        &.expired {
          color: #d9001b;
        }
      }
      a {
        text-decoration: underline;
        color: #2154bd;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 1680px) {
  .index-top-info {
    &::after {
      right: 5.6%;
    }
    .date {
      margin-right: 11.5%;
    }
  }
}
</style>
